import {Feature} from 'acng/core/model/feature.js';

const name = 'messenger';
export default name;
export const messengerFeature = new Feature(name);

messengerFeature.defineRemoveWhenHidden('onsw-kiss-button');
